const keyCodes = {
    KEY_CODE_TAB: 9,
    KEY_CODE_ENTER: 13,
    KEY_CODE_SPACE: 32,
    KEY_CODE_LARROW: 37,
    KEY_CODE_UARROW: 38,
    KEY_CODE_RARROW: 39,
    KEY_CODE_DARROW: 40
};

const specialValues = {
    UNKNOWN: 'UNKNOWN'
};

const LANGUAGES = {
    ENGLISH: {
        code: 'en_US',
        name: 'English'
    },
    SPANISH: {
        code: 'es_ES',
        name: 'Español'
    },
    PORTUGUESE: {
        code: 'pt_BR',
        name: 'Português'
    }
};

const MANUAL_CANCEL = 'MANUAL_CANCEL';

export default {
    keyCodes,
    specialValues,
    LANGUAGES,
    MANUAL_CANCEL
};
